import i18n from '../../i18n';

export const translationsStatus = {
  created: {
    label: i18n.t(`orders-management.status-created`),
    color: 'bg-primary-subtle text-primary',
  },
  waiting_payment: {
    label: i18n.t(`orders-management.status-waiting-payment`),
    color: 'bg-warning-subtle text-warning',
  },
  paid: {
    label: i18n.t(`orders-management.status-paid`),
    color: 'bg-success-subtle text-success',
  },
  invoiced: {
    label: i18n.t(`orders-management.status-invoiced`),
    color: 'bg-success-subtle text-success',
  },
  waiting_delivery: {
    label: i18n.t(`orders-management.status-waiting-delivery`),
    color: 'bg-warning-subtle text-warning',
  },
  delivered: {
    label: i18n.t(`orders-management.status-delivered`),
    color: 'bg-success-subtle text-success',
  },
  finished: {
    label: i18n.t(`orders-management.status-finished`),
    color: 'bg-success-subtle text-success',
  },
  partially_refunded: {
    label: i18n.t(`orders-management.status-partially-refunded`),
    color: 'bg-warning-subtle text-warning',
  },
  refunded: {
    label: i18n.t(`orders-management.status-refunded`),
    color: 'bg-success-subtle text-success',
  },
  canceled: {
    label: i18n.t(`orders-management.status-canceled`),
    color: 'bg-danger-subtle text-danger',
  },
  invalid: {
    label: i18n.t(`orders-management.status-invalid`),
    color: 'bg-danger-subtle text-danger',
  },
};
